import React from 'react'

import { useSearchParam } from '../../../../hooks/useSearchParam'
import { MembersTable } from './MembersTable'
import { Title } from './Title'

export const Members: React.FC = () => {
  const [searchParam, setSearchParam] = useSearchParam('search')

  return (
    <>
      <Title
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
      />
      <MembersTable
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
      />
    </>
  )
}
